"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = presetConstraint;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _constraintCartTotal = _interopRequireDefault(require("./constraintCartTotal"));

var _constraintCartOriginalTotal = _interopRequireDefault(require("./constraintCartOriginalTotal"));

var _constraintCartTaxonomyQuantitySum = _interopRequireDefault(require("./constraintCartTaxonomyQuantitySum"));

var _constraintRuleValidFrom = _interopRequireDefault(require("./constraintRuleValidFrom"));

var _constraintRuleValidTo = _interopRequireDefault(require("./constraintRuleValidTo"));

var _constraintSubjectQuantity = _interopRequireDefault(require("./constraintSubjectQuantity"));

function presetConstraint(extenstion) {
  return (0, _extends2.default)({
    cartTotal: _constraintCartTotal.default,
    cartOriginalTotal: _constraintCartOriginalTotal.default,
    cartTaxonomyQuantitySum: _constraintCartTaxonomyQuantitySum.default,
    ruleValidFrom: _constraintRuleValidFrom.default,
    ruleValidTo: _constraintRuleValidTo.default,
    subjectQuantity: _constraintSubjectQuantity.default
  }, extenstion);
}